module.exports = __webpack_public_path__ + "static/media/mobile-white-hamburger.5c2ba842.svg";